import { DownloadTrainingReportPdfDocument } from '@/api/queries';
import { DownloadTrainingReportPdfInput } from '@/models/gen/graphql';
import graphApi from '@/api';
import { saveFile } from '@/utils/promises';

const [, runRefetchDownloadTrainingReportPDF] = graphApi(DownloadTrainingReportPdfDocument);

export const downloadTrainingReportPDF = async (fileLocation: string): Promise<void> => {
  const input: DownloadTrainingReportPdfInput = { fileLocation };
  const res = await runRefetchDownloadTrainingReportPDF({ input });
  const presignedUrl = res?.downloadTrainingReportPDF?.presignedUrl;
  if (!presignedUrl) throw new Error('Failed to get download URL.');
  saveFile(presignedUrl);
};

export default downloadTrainingReportPDF;
